import { render, staticRenderFns } from "./CountryChangeActivationType.vue?vue&type=template&id=5772e5fc&"
import script from "./CountryChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./CountryChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports